export const MIN_QUICK_TRADE_LIMIT = 5;
export const MAX_QUICK_TRADE_LIMIT = 150000;
export const MIN_TRADE_LIMIT = 0;
export const MAX_TRADE_LIMIT = 5000;
export const APP_VERSION = "0.0.1-beta-2";
